import { LabReqTestOption } from '@care-portals/api-interfaces';

export const biochemistryFields: Array<LabReqTestOption> = [
  {
    type: 'boolean',
    id: 'glucose',
    label: 'Glucose',
    children: [
      { type: 'boolean', id: 'glucose_random', label: 'Random' },
      { type: 'boolean', id: 'glucose_fasting', label: 'Fasting' }
    ]
  },
  { type: 'boolean', id: 'hbA1C', label: 'HbA1C' },
  { type: 'boolean', id: 'creatinine', label: 'Creatinine (eGFR)' },
  { type: 'boolean', id: 'uricAcid', label: 'Uric Acid' },
  { type: 'boolean', id: 'sodium', label: 'Sodium' },
  { type: 'boolean', id: 'potassium', label: 'Potassium' },
  { type: 'boolean', id: 'alt', label: 'ALT' },
  { type: 'boolean', id: 'alk', label: 'Alk. Phosphatase' },
  { type: 'boolean', id: 'bilirubin', label: 'Bilirubin' },
  { type: 'boolean', id: 'albumin', label: 'Albumin' },
  {
    type: 'boolean',
    id: 'lipid',
    label:
      'Lipid Assessment (includes Cholesterol, HDL-C, Triglycerides, calculated LDL-C & Chol/HDL-C ratio; individual lipid tests may be ordered in the "Other Tests" section of this form)'
  },
  {
    type: 'boolean',
    id: 'albuminCreatinine',
    label: 'Albumin / Creatinine Ratio, Urine'
  },
  { type: 'boolean', id: 'urinalysis', label: 'Urinalysis (Chemical)' },
  { type: 'boolean', id: 'neonatal', label: 'Neonatal Bilirubin:' },
  {
    type: 'boolean',
    id: 'child',
    label: '',
    elements: [
      {
        label: "Child's Age",
        children: [
          { type: 'string', id: 'childAge_days', label: 'days' },
          { type: 'string', id: 'childAge_hours', label: 'hours' }
        ]
      },
      {
        label: '',
        children: [
          {
            type: 'string',
            id: 'clinicianTel',
            label: "Clinician/Practitioner's tel. no."
          }
        ]
      },
      {
        label: '',
        children: [
          {
            type: 'string',
            id: 'patientTel',
            label: "Patient's 24 hr telephone no."
          }
        ]
      }
    ]
  },
  {
    type: 'boolean',
    id: 'therapeutic',
    label: 'Therapeutic Drug Monitoring:'
  },
  {
    type: 'boolean',
    id: 'drugs',
    label: '',
    elements: [
      { children: [{ type: 'string', id: 'drug1', label: 'Name of Drug #1' }] },
      { children: [{ type: 'string', id: 'drug2', label: 'Name of Drug #2' }] },
      {
        label: 'Time Collected',
        children: [
          { type: 'string', id: 'time_collected_1', label: '#1' },
          { type: 'string', id: 'time_collected_2', label: '#2' }
        ]
      },
      {
        label: 'Time of Last Dose',
        children: [
          { type: 'string', id: 'lastDose_1', label: '#1' },
          { type: 'string', id: 'lastDose_2', label: '#2' }
        ]
      },
      {
        label: 'Time of Next Dose',
        children: [
          { type: 'string', id: 'nextDose_1', label: '#1' },
          { type: 'string', id: 'nextDose_2', label: '#2' }
        ]
      }
    ]
  }
];

export const hematologyFields: Array<LabReqTestOption> = [
  { type: 'boolean', id: 'cbc', label: 'CBC' },
  {
    type: 'boolean',
    id: 'prothrombinTime',
    label: 'Prothrombin Time (INR)'
  }
];

export const immunologyFields: Array<LabReqTestOption> = [
  { type: 'boolean', id: 'pregnancy', label: 'Pregnancy Test (Urine)' },
  {
    type: 'boolean',
    id: 'mononucleosis',
    label: 'Mononucleosis Screen'
  },
  { type: 'boolean', id: 'rubella', label: 'Rubella' },
  {
    type: 'boolean',
    id: 'prenatal',
    label: 'Prenatal: ABO, RhD, Antibody Screen (titre and ident. if positive)'
  },
  {
    type: 'boolean',
    id: 'repeatPrenatal',
    label: 'Repeat Prenatal Antibodies'
  }
];

export const microbiologyFields: Array<LabReqTestOption> = [
  { type: 'boolean', id: 'cervical', label: 'Cervical' },
  { type: 'boolean', id: 'vaginal', label: 'Vaginal' },
  {
    type: 'boolean',
    id: 'vaginalRectal',
    label: 'Vaginal / Rectal - Group B Strep'
  },
  {
    type: 'boolean',
    id: 'chlamydia',
    label: 'Chlamydia (specify source):',
    children: [
      {
        type: 'string',
        id: 'chlamydia_desc',
        label: ''
      }
    ]
  },
  {
    type: 'boolean',
    id: 'GC',
    label: 'GC (specify source):',
    children: [
      {
        type: 'string',
        id: 'GC_desc',
        label: ''
      }
    ]
  },
  { type: 'boolean', id: 'sputum', label: 'Sputum' },
  { type: 'boolean', id: 'throat', label: 'Throat' },
  {
    type: 'boolean',
    id: 'wound',
    label: 'Wound (specify source):',
    children: [
      {
        type: 'string',
        id: 'wound_desc',
        label: ''
      }
    ]
  },
  { type: 'boolean', id: 'urine', label: 'Urine' },
  { type: 'boolean', id: 'stoolCulture', label: 'Stool Culture' },
  { type: 'boolean', id: 'stoolOva', label: 'Stool Ova & Parasites' },
  {
    type: 'boolean',
    id: 'otherSwabs',
    label: 'Other Swabs / Pus (specify source)',
    children: [
      {
        type: 'string',
        id: 'otherSwabs_desc',
        label: ''
      }
    ]
  }
];

export const viralFields: Array<LabReqTestOption> = [
  { type: 'boolean', id: 'acute', label: 'Acute Hepatitis' },
  { type: 'boolean', id: 'chronic', label: 'Chronic Hepatitis' },
  {
    type: 'boolean',
    id: 'immuneStatus',
    label: '',
    elements: [
      {
        label: 'Immune Status / Previous Exposure',
        children: [{ type: 'boolean', id: 'hepatitisA', label: 'Hepatitis A' }]
      },
      {
        children: [{ type: 'boolean', id: 'hepatitisB', label: 'Hepatitis B' }]
      },
      {
        children: [{ type: 'boolean', id: 'hepatitisC', label: 'Hepatitis C' }]
      }
    ]
  }
];

export const psaFields: Array<LabReqTestOption> = [
  { type: 'boolean', id: 'totalPSA', label: 'Total PSA' },
  { type: 'boolean', id: 'freePSA', label: 'Free PSA' },
  {
    type: 'boolean',
    id: 'insured',
    label: 'Insured – Meets OHIP eligibility criteria'
  },
  {
    type: 'boolean',
    id: 'uninsured',
    label: 'Uninsured – Screening: Patient responsible for payment'
  }
];

export const vitaminFields: Array<LabReqTestOption> = [
  {
    type: 'boolean',
    id: 'insured',
    label: `Insured - Meets OHIP eligibility criteria: 
    osteopenia; osteoporosis; rickets;
    renal disease; malabsorption syndromes; :
    medications affecting vitamin D metabolism`
  },
  {
    type: 'boolean',
    id: 'uninsured',
    label: 'Uninsured - Patient responsible for payment'
  }
];

export const otherTestsFields: Array<LabReqTestOption> = [
  { type: 'list', id: 'test', label: 'Test' }
];
